/**
 * ProductsPage - Page wrapper for products management
 */

import React from "react";
import ProductsView from "../features/products/views/ProductsView";

const ProductsPage = () => {
  return <ProductsView />;
};

export default ProductsPage;






